import React, {useState, useEffect, useMemo, useRef} from 'react';
import {myService} from '@app/services/donhangService';
import {alertService} from '@app/services/alertService';
import {useLocation} from 'react-router-dom';
import './order-table-style.css';
import * as mainService from '@app/services/mainService';
import {Input, Tabs} from "@components";
import {getControllerName, getDefaultSelectValue,renewTrangthai} from '@app/utils/helpers';
import {
    image_root,
    INIT_ROLE_MENU,
    PAGES_SIZE_DEFAULT, SERVER_YYYYMM_FORMAT
} from '@app/const/AppSetting';
import HeaderClick from '@app/utils/HeaderClick';
import Pagination from "@material-ui/lab/Pagination";
import {useDispatch, useSelector} from "react-redux";
import {DownloadFile,findObjInArr, formatCurencyVI, formatDateClient, getMenuName, isEmpty} from "@app/utils/CommonFunctions";
import Select, { components } from "react-select";
import {useTranslation} from "react-i18next";
import {Card, HRTag} from "@components";
import {loadMenu} from "@store/reducers/auth";
import {Button, Modal} from "react-bootstrap";
import {saveAs} from 'file-saver';
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {trangthaiSlice} from "@store/reducers/trangthaiSlice";
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import NewDataButton from '@app/utils/NewDataButton';
import {ClipLoader} from "react-spinners";
import NewDatePicker from "@pages/FUtil/NewDatePicker";
import KhachhangListComponent from "@pages/FUtil/KhachhangListComponent";
import LoaidonhangListComponent from "@pages/FUtil/LoaidonhangListComponent";
import OrderStatusPopover from "@pages/FUtil/OrderStatusPopoverComponent";
import NhanvienListComponent from "@pages/FUtil/NhanvienListComponent";
import NhanvienAllListComponent from "@pages/FUtil/NhanvienAllListComponent";

const DonhangList = ({ history }) => {
    const [t] = useTranslation();
    const pageSizes = PAGES_SIZE_DEFAULT;
    const location = useLocation();
    const currController = getControllerName(location.pathname);
    const dispatch = useDispatch();
    const menu = useSelector((state) => state.auth.menu);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);
    let user = useSelector((state) => state.auth.currentUser);
    let userTmp = localStorage.getItem("profile");
    if(userTmp)
        user = JSON.parse(userTmp);

    // Thêm state để quản lý auto refresh
    const [autoRefresh, setAutoRefresh] = useState(true);
    const [countdown, setCountdown] = useState(30);
    const intervalRef = useRef(null);
    const countdownRef = useRef(null);

    // Thêm function để parse query parameters
    const getQueryParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            status: searchParams.get('status'),
            // Có thể thêm các params khác nếu cần
        };
    };

    const getOrderStatusClass = (status) => {
        switch (status) {
            case 0: return 'status-secondary';     // Xám
            case 1: return 'status-info';          // Xanh dương nhạt
            case 2: return 'status-primary';
            case 3: return 'status-primary';
            case 4: return 'status-primary';
            case 5: return 'status-primary';
            case 9: return 'status-primary';       // Xanh dương đậm
            case 6: return 'status-warning';       // Vàng
            case 7: return 'status-success';       // Xanh lá cây (hoàn thành)
            case 8: return 'status-dark';
            default: return 'status-danger';       // Mặc định nếu không xác định
        }
    };

    const getBadgeClass = (status) => {
        switch (status) {
            case 0: return 'badge-secondary';     // Xám
            case 1: return 'badge-info';          // Xanh dương nhạt
            case 2: return 'badge-primary';
            case 3: return 'badge-primary';
            case 4: return 'badge-primary';
            case 5: return 'badge-primary';
            case 9: return 'badge-primary';        // Xanh dương đậm
            case 6: return 'badge-warning';       // Vàng
            case 7: return 'badge-success';         // Xanh lá cây (hoàn thành)
            case 8: return 'badge-dark';
            default: return 'badge-alert';        // Mặc định nếu không xác định
        }
    };

    const queryParams = getQueryParams();
    const initialSearchItems =
    {
        ten:  "",
        ma:  "",
        trangthai_fk: queryParams.status ? parseInt(queryParams.status) : null,
        searchbyText: '',
        /*tu_ngay: new Date().toISOString().split('T')[0],*/
        tu_ngay: new Date(new Date().setDate(new Date().getDate() - 14)).toISOString().split('T')[0],
        den_ngay: new Date().toISOString().split('T')[0],
        khachhang_fk :null,
        loaidonhang_fk: null,
        nhanvien_fk: null
    };

    // Function để merge query params với initial search items
    const getInitialSearchItemsWithQuery = () => {
        const queryParams = getQueryParams();
        return {
            ...initialSearchItems,
            trangthai_fk: queryParams.status ? parseInt(queryParams.status) : null,
        };
    };

    const [searchItems, setSearchItems] = useState(getInitialSearchItemsWithQuery());
    const [removeToogle, setRemoveToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingTicket, setLoadingTicket] = useState(false);
    const [objs, setObjs] = useState([]);
    const [objAlls, setObjAlls] = useState([]);

    //const [searchItems, setSearchItems] = useState({ ...initialSearchItems });
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    const [activeTab, setActiveTab] = useState(0);

    // Hàm bắt đầu auto refresh
    const startAutoRefresh = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        if (countdownRef.current) clearInterval(countdownRef.current);

        setCountdown(30);

        // Countdown timer
        countdownRef.current = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    return 30;
                }
                return prev - 1;
            });
        }, 1000);

        // Auto refresh timer - sử dụng closure để capture searchItems hiện tại
        intervalRef.current = setInterval(() => {
            const { storedPage, storedPageSize } = getStoredPaginationState();
            // Cập nhật lại state component để đồng bộ với Redux store
            setPage(storedPage);
            setPageSize(storedPageSize);
            // Gọi retrieveTutorials với searchItems hiện tại từ state
            setSearchItems(currentSearchItems => {
                retrieveTutorials(currentSearchItems, storedPage, storedPageSize);
                return currentSearchItems; // Không thay đổi state
            });
        }, 30000); // 30 giây
    };

    // Hàm dừng auto refresh
    const stopAutoRefresh = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        if (countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
        }
        setCountdown(30);
    };

    // Toggle auto refresh
    const toggleAutoRefresh = () => {
        setAutoRefresh(prev => {
            const newValue = !prev;
            if (newValue) {
                startAutoRefresh();
            } else {
                stopAutoRefresh();
            }
            return newValue;
        });
    };

    // Cleanup intervals khi component unmount
    useEffect(() => {
        return () => {
            stopAutoRefresh();
        };
    }, []);

    // Bắt đầu auto refresh khi component mount và autoRefresh = true
    useEffect(() => {
        if (autoRefresh && !loading) {
            // Restart interval khi searchItems thay đổi để đảm bảo dùng filter mới nhất
            startAutoRefresh();
        }
        return () => {
            if (!autoRefresh) {
                stopAutoRefresh();
            }
        };
    }, [autoRefresh, loading]); // Bỏ searchItems khỏi dependency để tránh restart liên tục

    const onchangeInput2 = (name, e) => {
        setLoadingTicket(true);
        let value = e?.target?.value ?? e; // Lấy giá trị từ e.target.value hoặc trực tiếp từ e nếu là giá trị ngày
        console.log("onchangeInput - name:", name, "value:", e); // Debug
        let search = {
            ...searchItems,
            [name]: value
        };
        setPage(1); // Reset page về 1 khi filter thay đổi
        setSearchItems(search);
        storeSearchItems(search,1,pageSize);
        setLoadingTicket(false);
    };

    const onSelectedChangeFilter = async (name, e) => {
        setLoadingTicket(true);
        let search = searchItems;
        search = { ...search, [name]: e ? e.value : '' };
        setPage(1); // Reset page về 1 khi filter thay đổi
        setSearchItems(search);
        storeSearchItems(search,1,pageSize);
        //await retrieveTutorials(search);
        setLoadingTicket(false);
    };

    useEffect(() => {
        if (Object.keys(searchItems).length > 0) {
            retrieveTutorials(searchItems);
        }
    }, [searchItems]);

    // Hàm lưu trữ cả searchItems và pagination state
    const storeSearchItems = (searchItems, currentPage = page, currentPageSize = pageSize) => {
        // Thêm kiểm tra menu tồn tại
        if (menu && menu.length > 0) {
            const newMenu = menu.map((elem) => {
                return {
                    ...elem,
                    children: elem.children ? elem.children.map((item) =>
                        item.path && item.path.includes(currController) ? {
                            ...item,
                            searchItems: searchItems,
                            currentPage: currentPage,
                            currentPageSize: currentPageSize
                        } : item,
                    ) : []
                };
            });
            dispatch(loadMenu(newMenu));
        }
    };

    // Hàm lấy pagination state từ store

    const getStoredPaginationState = () => {
        let storedPage = 1;
        let storedPageSize = pageSizes[2];

        // Thêm kiểm tra menu tồn tại
        if (menu && menu.length > 0) {
            menu.forEach((elem) => {
                if (elem.children && elem.children.length > 0) {
                    const m = elem.children.find((item) => item.path && item.path.includes(currController));
                    if (m !== undefined) {
                        storedPage = m.currentPage || 1;
                        storedPageSize = m.currentPageSize || pageSizes[2];
                    }
                }
            });
        }

        return { storedPage, storedPageSize };
    };

    const retrieveTutorials = async (search,currentPage = null, currentPageSize = null) => {
        if(!search)
            search = searchItems;

        // Sử dụng page hiện tại từ tham số hoặc từ state
        const pageToUse = currentPage || page;
        const pageSizeToUse = currentPageSize || pageSize;

        const { data, pageinfo } = await myService
            .getAll(pageToUse, pageSizeToUse, search);
        setObjs(data);
        setObjAlls(data);
        setCount(pageinfo.totalpage);
    };

    const createRs = async () => {
        setLoading(true);
        setLoading(false);
    }

    // Modified loadTable function
    const loadTable = async () => {
        setLoadingTicket(true);
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        const queryParams = getQueryParams();
        let search = {};
        let storedPage = 1;
        let storedPageSize = pageSizes[2];

        if (queryParams.status) {
            search = getInitialSearchItemsWithQuery();
            // ✅ THÊM: Vẫn restore page và pageSize từ menu khi có query params
            if (menu && menu.length > 0) {
                menu.forEach((elem) => {
                    if (elem.children && elem.children.length > 0) {
                        const m = elem.children.find((item) => item.path && item.path.includes(currController));
                        if (m !== undefined) {
                            storedPage = m.currentPage || 1;
                            storedPageSize = m.currentPageSize || pageSizes[2];
                        }
                    }
                });
            }
        } else {
            // Restore đầy đủ khi không có query params
            if (menu && menu.length > 0) {
                menu.forEach((elem) => {
                    if (elem.children && elem.children.length > 0) {
                        const m = elem.children.find((item) => item.path && item.path.includes(currController));
                        if (m !== undefined) {
                            search = m.searchItems || initialSearchItems;
                            storedPage = m.currentPage || 1;
                            storedPageSize = m.currentPageSize || pageSizes[2];
                        }
                    }
                });
            }
        }

        setPage(storedPage);
        setPageSize(storedPageSize);
        setSearchItems(search);
        storeSearchItems(search, storedPage, storedPageSize);
        await retrieveTutorials(search, storedPage, storedPageSize);

        let divtb1 = document.getElementById("divtb1");
        setActiveTab(divtb1 ? 0 : 1);
        setLoadingTicket(false);
    };

    const onChangeInput = (e) => {
        const {name, value} = e.target;
        const newSearchItems = {
            ...searchItems,
            [name]: value
        };

        setPage(1); // Reset page về 1 khi filter thay đổi
        setSearchItems(newSearchItems);
        storeSearchItems(newSearchItems, 1, pageSize);
    };

    useEffect(() => {
        const initializeComponent = async () => {
            await mainService.checkRole({
                pathname: location.pathname,
                isAddMode: false,
                currController,
                history
            });
            console.log('currController:'+currController);
            await createRs();
        };

        initializeComponent();
    }, []);

    // Effect để handle query params changes
    useEffect(() => {
        const queryParams = getQueryParams();
        if (queryParams.status) {
            const searchWithQuery = getInitialSearchItemsWithQuery();
            // ✅ Lấy page và pageSize hiện tại từ menu
            const { storedPage, storedPageSize } = getStoredPaginationState();
            setSearchItems(searchWithQuery);
            setPage(storedPage);
            setPageSize(storedPageSize);
            storeSearchItems(searchWithQuery, storedPage, storedPageSize);
        }
    }, [location.search]);

    useEffect(() => {
        const handleStateChange = async () => {
            await createRs();
            await loadTable();
        };

        handleStateChange();
    }, [removeToogle, page, pageSize]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    const findByTitle = async () => {
        setLoading(true);
        setPage(1);
        // Lưu page = 1 khi search
        storeSearchItems(searchItems, 1, pageSize);
        await retrieveTutorials(searchItems, 1, pageSize); // Truyền searchItems hiện tại
        setLoading(false);
    };

    // Modified removeSearch function
    const removeSearch = async () => {
        setPage(1);
        const queryParams = getQueryParams();

        // Nếu có query params từ URL, reset về query params đó thay vì baseInitialSearchItems
        const resetSearchItems = queryParams.status
            ? getInitialSearchItemsWithQuery()
            : initialSearchItems;

        setSearchItems(resetSearchItems);
        // Reset page về 1 khi clear search
        storeSearchItems(resetSearchItems, 1, pageSize);
        setRemoveToogle((prevSelected) => !prevSelected);
    };
    const handlePageChange = (event, value) => {
        setPage(value);
        // Lưu page mới vào store
        storeSearchItems(searchItems, value, pageSize);
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = event.target.value;
        setPageSize(newPageSize);
        // Lưu page size mới và reset page về 1
        storeSearchItems(searchItems, 1, newPageSize);
    };

    const editdonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/edit/${id}`);
    };

    const opendonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/view/${id}`);
    };

    const deletedonhang = async (rowIndex) => {
        const { id } = objs[rowIndex];
        const result = await myService.Delete(id);
        if (result.status === "1") {
            alertService.success(t('fields.label.xoathanhcong'));
            await retrieveTutorials(searchItems); // Truyền searchItems hiện tại
        } else {
            alertService.error(result.msg);
        }
    };
    const printdonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/print/${id}`);
    };

    const excel = async () => {
        setLoading(true);

        await myService.excel(page, pageSize, searchItems).then((d) => {
            //  console.log(d);
            const blob = new Blob([d.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob,roleMenu.tenmenu);
        }).catch(alertService.error);
        setLoading(false);
    };

    const excelHD = async () => {
        setLoading(true);

        await myService.excelHD(page, pageSize, searchItems).then((d) => {
            //  console.log(d);
            const blob = new Blob([d.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob,roleMenu.tenmenu);
        }).catch(alertService.error);
        setLoading(false);
    };

    const excelPath = async (action) => {
        setLoading(true);

        const result = await myService.excelPath({...searchItems,uploadType :action});
        setLoading (false);
        if (result.status==="1") {

            await  DownloadFile( image_root + result.data, result.data2);

        } else {
            alertService.error(result.msg,);
        }

    };

    // Chỉ phần viewTable được cập nhật với các class name mới
    const viewTable = (
        loadingTicket ?
            <div className="order-loading-container">
                <ClipLoader color="#3498db" size={50} />
            </div>
            :
            <div className="card-body table-bordered table-responsive p-0">
                <table className="table table-hover text-nowrap">
                    <thead>
                    <tr>
                        <th>No</th>
                        <th className="text-center" style={{ minWidth: '180px' }}>Thông tin chung</th>
                        <th className="text-center">Trạng thái</th>
                        <th className="text-center" style={{ minWidth: '180px' }}>Ngày</th>
                        <th className="text-center" style={{ minWidth: '280px' }}>Khách hàng</th>
                        <th className="text-center" style={{ maxWidth: '300px', minWidth: '250px' }}>
                            Chi tiết đơn hàng
                        </th>
                        <th className="text-center">Tác vụ</th>
                    </tr>
                    </thead>
                    <tbody>
                    {objs && objs.map((item, i) => {
                        let editable = [];

                        if (roleMenu.quyenhienthi === 1) {
                            editable = [
                                ...editable,
                                <button
                                    className="btn btn-sm action-btn action-btn-view"
                                    key={`view-donhangcls-${i}`}
                                    title={t('action.label.view')}
                                    onClick={() => opendonhang(i)}
                                >
                                    <i className="fas fa-search"></i>
                                </button>,
                            ];
                        }

                        if (roleMenu.quyenchinhsua === 1 &&
                            item.trangthai_fk !== 7 &&
                            (user.nhomnhanvien_fk !== "1" ||
                                (user.nhomnhanvien_fk === "1" && ([0, 5, 6].includes(item.trangthai_fk))))) {
                            editable = [
                                ...editable,
                                <button
                                    className="btn btn-sm action-btn action-btn-edit"
                                    key={`edit-donhangcls-${i}`}
                                    title={t('action.label.edit')}
                                    onClick={() => editdonhang(i)}
                                >
                                    <i className="fas fa-edit"></i>
                                </button>,
                            ];
                        }

                        if (roleMenu.quyenxoa === 1 && item.trangthai_fk !== 7) {
                            editable = [
                                ...editable,
                                <button
                                    className="btn btn-sm action-btn action-btn-delete"
                                    key={`delete-donhangcls-${i}`}
                                    title={t('action.label.delete')}
                                    onClick={() => {
                                        if (window.confirm(t('fields.label.bancomuonxoa')))
                                            deletedonhang(i);
                                    }}
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </button>,
                            ];
                        }

                        return (
                            item && (
                                <tr key={`item-donhangcls-${i}`}>
                                    <td className="text-center">{item._no}</td>

                                    {/* Merged column: Loại đơn + Mã */}
                                    <td className="order-general-info-col">
                                        <div className="order-info-card">
                                            <div>
                                            <span className={`order-badge order-type-badge ${
                                                item.loai_don_hang === 'LÀM MỚI' ? 'order-type-new' :
                                                    item.loai_don_hang === 'BẢO HÀNH' ? 'order-type-warranty' :
                                                        item.loai_don_hang === 'LÀM LẠI' ? 'order-type-remake' :
                                                            'order-type-default'
                                            }`}>
                                                {item.loai_don_hang}
                                            </span>
                                            </div>

                                            <div>
                                                <OrderStatusPopover orderId={item.id} placement="left">
                                                <span className={`order-badge order-status-badge ${getOrderStatusClass(item.trangthai_fk)}`}>
                                                    {item.ma}
                                                </span>
                                                </OrderStatusPopover>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Status column */}
                                    <td className="order-status-col">
                                        <div>
                                            {(item.is_gap === true || item.is_gap === 1) && item.trangthai_fk !== 7 && (
                                                <span className="order-badge order-urgent-badge">
                                                GẤP
                                            </span>
                                            )}
                                        <span className={`order-badge order-status-badge ${getOrderStatusClass(item.trangthai_fk)}`}>
                                            {item.trang_thai}
                                        </span>

                                        </div>
                                    </td>

                                    {/* Date column */}
                                    <td className="order-date-col">
                                        <div className="order-info-card">
                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-secondary">
                                                Ngày đơn
                                            </span>
                                                <span className="order-text">
                                                {item.ngay}
                                            </span>
                                            </div>

                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-orange">
                                                Ngày giao
                                            </span>
                                                <span className="order-text">
                                                {item.ngay_giao_dukien}
                                            </span>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Customer info column */}
                                    <td className="order-customer-col">
                                        <div className="order-info-card">
                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-primary">
                                                Nha khoa
                                            </span>
                                                <span className="order-text order-text-large">
                                                {item.nha_khoa}
                                            </span>
                                            </div>

                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-success">
                                                Nha sỹ
                                            </span>
                                                <span className="order-text order-text-large">
                                                {item.nha_sy}
                                            </span>
                                            </div>

                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-warning">
                                                Bệnh nhân
                                            </span>
                                                <span className="order-text order-text-large">
                                                {item.benh_nhan}
                                            </span>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Order details column */}
                                    <td className="order-details-col">
                                        <div className="order-details-card">
                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-primary">
                                                Chỉ định
                                            </span>
                                                <span className="order-text">
                                                {item.chi_dinh_san_pham}
                                            </span>
                                            </div>

                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-success">
                                                Màu
                                            </span>
                                                <span className="order-text">
                                                {item.colors}
                                            </span>
                                            </div>

                                            <div className="order-info-row">
                                            <span className="order-badge order-label order-label-warning">
                                                Ghi chú
                                            </span>
                                                <span className="order-text">
                                                {item.ghi_chu}
                                            </span>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Actions column */}
                                    <td className="text-center">{editable}</td>
                                </tr>
                            )
                        );
                    })}
                    </tbody>
                </table>
            </div>
    );

    return !loading && (
        <div className="card card-primary">
            <HeaderClick
                isIndex
                headerName={roleMenu.tenmenu}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <Card title={t('fields.label.boloctimkiem')} isDefaultActive>
                    <div className="card-body">
                        <div className="form-row small">

                            {/*<div className="form-group col-md-2">
                                <TrangthaiListComponent trangthai_fk = {searchItems.trangthai_fk}
                                    onChange ={(e) => onSelectedChangeFilter('trangthai_fk', e)}
                                    filterIds = { [0,1] }
                                    trangthaiName = "name"
                                />
                            </div>*/}
                            <div className="form-group-sm col-sm-2">
                                <label>Mã đơn hàng/Bệnh nhân/Nha sỹ</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    name="search_text"
                                    id ="search_text"
                                    value={searchItems.search_text}
                                    onChange={(e) => onSelectedChangeFilter('search_text', e.target)}
                                    /*onBlur={(e) => onSelectedChangeFilter('ma', e.target)}*/
                                />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <label >Từ ngày</label>
                                <NewDatePicker required = "required" className="form-control w-100" isV2 id="tu_ngay" name="tu_ngay" value={searchItems.tu_ngay} onDayChange={(date) => onchangeInput2("tu_ngay", date)} />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <label >Đến ngày</label>
                                <NewDatePicker required = "required" className="form-control w-100" isV2 id="den_ngay" name="den_ngay" value={searchItems.den_ngay} onDayChange={(date) => onchangeInput2("den_ngay", date)} />
                            </div>
                            <div className="form-group col-md-2">
                                <TrangthaiListComponent trangthai_fk = {searchItems.trangthai_fk}
                                                        onChange ={(e) => onSelectedChangeFilter('trangthai_fk', e)}
                                                        filterIds = { [0,1,2,3,4,5,6,7,8,9] }
                                                        trangthaiName = "so_name"
                                />
                            </div>
                            <div className="form-group col-md-2">
                                <KhachhangListComponent name='khachhang_fk' labelName='Nha khoa' value={searchItems.khachhang_fk}
                                                        onChange={(opt) => onChangeInput({ target: { name: "khachhang_fk", value: opt?.value } })} />
                            </div>
                            <div className="form-group col-md-2">
                                <LoaidonhangListComponent name='loaidonhang_fk' labelName='Loại đơn hàng' loaidonhang_fk={searchItems.loaidonhang_fk}
                                                          onChange={(opt) => onChangeInput({ target: { name: "loaidonhang_fk", value: opt?.value } })} />
                            </div>
                            <div className="form-group col-md-2">
                                <NhanvienAllListComponent name='nhanvien_fk' searchable={true} labelName='Nhân viên' nhanvien_fk={searchItems.nhanvien_fk}
                                                          onChange={(opt) => onChangeInput({ target: { name: "nhanvien_fk", value: opt?.value } })} />
                            </div>

                        </div>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-info mr-1" type="button" onClick={findByTitle}>
                            <i className="fa fa-search"></i>
                        </button>
                        <button className="btn btn-dark mr-1" type="button" onClick={removeSearch}>
                            <i className="fa fa-undo"></i>
                        </button>
                        <Button type="button" className="btn btn-primary mr-1" onClick={() =>{ excel();}}>
                            <i className="fa fa-file-excel">   {`Excel` }</i>
                        </Button>
                        {/*{roleMenu.quyenin === 1 && (
                            <Button type="button" className="btn btn-primary mr-1" onClick={() => { excelHD(); }}>
                                <i className="fa fa-file-excel"> {`Excel HÓA ĐƠN`}</i>
                            </Button>
                        )}*/}

                        <NewDataButton
                            route={location.pathname}
                            roleMenu={roleMenu}
                            history={history}
                        />

                        {/* Nút điều khiển Auto Refresh */}
                        <Button
                            type="button"
                            className={`btn mr-1 ${autoRefresh ? 'btn-success' : 'btn-secondary'}`}
                            onClick={toggleAutoRefresh}
                            title={autoRefresh ? 'Tắt tự động làm mới' : 'Bật tự động làm mới'}
                        >
                            <i className={`fa ${autoRefresh ? 'fa-pause' : 'fa-play'}`}></i>
                            {autoRefresh ? ` Tắt (${countdown}s)` : ' Bật Auto Refresh'}
                        </Button>
                    </div>
                </Card>

                <HRTag title={t('fields.label.ketqua') + ' - '+ t('fields.label.list')}/>

                {viewTable}

                <div className="mt-3">
                    {t('footer.itemperpage')}
                    <select onChange={handlePageSizeChange} value={pageSize}>
                        {pageSizes.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>

                    <Pagination
                        className="my-3"
                        count={count}
                        page={page}
                        siblingCount={1}
                        boundaryCount={1}
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePageChange}
                    />
                </div>

            </div>
        </div>
    );
};

export default DonhangList;